/**
 * Processing's RUN-END POCKET, named in one place for the code that builds it
 * and the code that must recognise it.
 *
 * Where a perpendicular run stands in a run's depth at its end — two walls that
 * do not meet, a bump in the corner — post-processing fills the leftover strip
 * with a filler only as deep as the room left (`fillRunEndPockets`,
 * functions/features/post-processing/kitchen.js). No run builds a body
 * shallower than its own, so a run that claimed one swept it on the first edit
 * and filled the strip at full depth, into the other run's end (F6D83996,
 * 48 King's Drive, 2026-10-23). `cabinetLayoutToRuns` therefore leaves it out of
 * the run: not owned, and not part of the run's extent.
 *
 * The id is keyed on the WALL and the end, never on the donor cabinet — see the
 * builder — so it is also the one thing every pocket already saved carries.
 *
 * Pure. No I/O.
 */

const RUN_END_POCKET_ID_PREFIX = 'run_end_pocket_';

/** The pocket's id at one end (`side`) of the run on `wallId`. */
function runEndPocketId(wallId, side) {
  return `${RUN_END_POCKET_ID_PREFIX}${wallId || 'wall'}_${side}`;
}

/** Whether `obj` is a run-end pocket filler. */
function isRunEndPocket(obj) {
  return (
    obj?.type === 'lower-cabinet' &&
    typeof obj.id === 'string' &&
    obj.id.startsWith(RUN_END_POCKET_ID_PREFIX)
  );
}

module.exports = { RUN_END_POCKET_ID_PREFIX, runEndPocketId, isRunEndPocket };
